<template>
  <div id="app">
    <HeaderPc v-if="type === 'pc'"/>
    <HeaderMb v-if="type === 'mb'" ref="mbHeader" @showMenu="showMenu"/>
    <MenuMb v-if="type === 'mb' && showMbMenu" @showMenu="showMenu"/>
    <router-view/>
    <FootPc v-if="type === 'pc'"/>
    <GoTopPc v-if="type === 'pc'"/>
    <FootMb v-if="type === 'mb'"/>
    <GoTopMb v-if="type === 'mb'"/>

  </div>
</template>
<script>
import HeaderPc from '@/components/pc/header.vue'
import FootPc from '@/components/pc/foot.vue'
import GoTopPc from '@/components/pc/goTop.vue'
import HeaderMb from '@/components/mb/header.vue'
import MenuMb from '@/components/mb/menu.vue'
import FootMb from '@/components/mb/foot.vue'
import GoTopMb from '@/components/mb/goTop.vue'

export default {
  name: 'HomeView',
  components: {
    HeaderPc,
    FootPc,
    GoTopPc,
    HeaderMb,
    MenuMb,
    FootMb,
    GoTopMb
  },
  data() {
    return {
      type : 'pc',
      showMbMenu: false
    }
  },
  created() {
    this.type = 'pc'
    if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      this.type = 'mb'
    }
    document.addEventListener('contextmenu', event => event.preventDefault());
  },
  methods: {
   showMenu(data) {
    if (data.type == 2) {
      this.$refs.mbHeader.clickMenu = false
    }
    this.showMbMenu = !this.showMbMenu
   }
  }
}
</script>

<style lang="scss">
body {
  width: 100%;
  margin: 0;
  padding: 0;
  touch-action: manipulation;
  -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none;
  div {
    box-sizing: border-box;
    background-size: 100% !important;
  }
  
}
</style>
